/**
* @Author: 858834013@qq.com
* @Name: index
* @Date: 2022-08-24
* @Desc:
*/
<template>
  <div class="itemBody">
    <titleInfo @getHide="getHide" :title="title">
      <tab :list="tablist" :active.sync="active"></tab>
    </titleInfo>
    <div class="itemBodyMain">
      <div class="itemBodyMainl">
        <echarts :active="active" ></echarts>
      </div>
      <div class="itemBodyMainr">
        <div class="Item" v-for="(item) in powerdata">
          <div class="Iteml">
            <numcard  :num=item.count></numcard>
          </div>
          <div class="Itemr">{{ item.faultName }}</div>
        </div>
<!--        <div class="Item">-->
<!--          <div class="Iteml">-->
<!--            <numcard num="54"></numcard>-->
<!--          </div>-->
<!--          <div class="Itemr">过压故障</div>-->
<!--        </div>-->
<!--        <div class="Item">-->
<!--          <div class="Iteml">-->
<!--            <numcard num="12"></numcard>-->
<!--          </div>-->
<!--          <div class="Itemr">欠压故障</div>-->
<!--        </div>-->
<!--        <div class="Item">-->
<!--          <div class="Iteml">-->
<!--            <numcard num="13"></numcard>-->
<!--          </div>-->
<!--          <div class="Itemr">温度报警</div>-->
<!--        </div>-->
<!--        <div class="Item">-->
<!--          <div class="Iteml">-->
<!--            <numcard num="14"></numcard>-->
<!--          </div>-->
<!--          <div class="Itemr">剩余电流故障</div>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import titleInfo from "@/components/titleInfo";
import tab from "./components/tab";
import numcard from "./components/numcard";
import echarts from "./components/echarts";
import Axios from "@/utils/Axios";
import qs from "qs";
import Bus from "@/utils/bus.js";

export default {
  name: "index",
  components: {titleInfo, tab, numcard, echarts},
  props: {
    title: {
      type: String,
      default() {
        return '';
      }
    },

  },
  data() {
    return {
      status: '',
      active: 1,
      alldata: 0,
      depid:"",
      powerdata:[],
      tablist: [{
        name: '当日',
        id: 1,
      }, {
        name: '近七天',
        id: 7,
      }, {
        name: '全部',
        id: null
      }]
    }
  },
  watch: {
    active() {
      this.getpowdata()
    },

  },
  mounted() {

    let that=this
    this.depid= Number(localStorage.getItem("deptId"));
    this.getpowdata()
    Bus.$on('changeid',(val)=>{
      that.depid=val.deptId
      that.getpowdata()
    })
  },
  methods: {
    getpowdata(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/portal/eventSortStatis"

      param.data=qs.stringify({
        day:this.active,
        deptId:this.depid,
      })
      Axios.ajax(param).then((res)=>{
        if(res.resultCode=='0'){
          if(res.data.length){
            this.powerdata=res.data
          }else{
            this.powerdata=[
              {
                "faultName": "欠压故障",
                "count": 0
              },
              {
                "faultName": "过流故障",
                "count": 0
              },
              {
                "faultName": "过压故障",
                "count": 0
              },
              {
                "faultName": "温度报警",
                "count": 0
              },
              {
                "faultName": "剩余电流故障",
                "count": 0
              }
            ]
          }


          let daat=0
        for(let i=0;i<res.data.length;i++){
          daat+=res.data[i].count
        }
          this.alldata=daat
        }else{

        }

      })
    },
    getHide() {
      this.$emit('getHide', 0)
    },
  }
}
</script>

<style lang="scss" scoped>
.itemBody {
  position: relative;
  width: 100%;
  height: 100%;

  .itemBodyMain {
    width: 100%;
    position: relative;
    height: calc(100% - 50px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    align-content: flex-start;

    .itemBodyMainl {
      width: 40%;
      position: relative;
      height: 100%;
    }

    .itemBodyMainr {
      width: 60%;
      position: relative;
      top: 0px;
      left: 20px;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: column;
      align-content: flex-start;

      .Item {
        height: 20%;
        position: relative;
        display: flex;
        /*justify-content: flex-end;*/
        align-items: flex-end;
        flex-wrap: nowrap;
        flex-direction: row;
        width: 100%;
        align-content: flex-start;

        .Iteml {
          background: url("../../../assets/home/stagebg.png") center bottom no-repeat;
          width: 99px;
          height: 100%;
          position: relative;
        }

        .Itemr {
          font-size: 16px;
          font-family: PingFang;
          font-weight: 500;
          color: #47c4ff;
          margin-right: 15px;
          margin-left: 15px;
        }
      }
    }

  }
}
</style>
